import script from "./AssessmentDetailContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentDetailContent.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentDetailContent.vue?vue&type=style&index=0&id=16fcff12&lang=scss&scoped=true"
import "./AssessmentDetailContent.vue?vue&type=style&index=1&id=16fcff12&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fcff12"]])

export default __exports__